import {
  generateIstockImageSrc,
  generateAlternativeIstockBgImageSrc,
} from './generate-istock-image-src';

export default {
  generateIstockImageSrc,
  generateAlternativeIstockBgImageSrc,
};
